import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=4d46bbdf&scoped=true&"
import script from "@/views/Users/Teacher/Levels.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Teacher/Levels.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Teacher/levels.scss?vue&type=style&index=0&id=4d46bbdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46bbdf",
  null
  
)

export default component.exports